<template>
  <div class="generalEstimate">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.factoryReport.Conclusion') }}
    </div>
    <div class="generalEstimate-con">
      <!-- <div> -->
      <a-form>
        <a-form-item
          :label="$tc('lang.factoryReport.Advantage')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <div v-for="(item, index) in freportAdvantage" :key="index">
            <a-input v-model="freportAdvantage[index]" />
          </div>
        </a-form-item>
        <a-form-item
          :label="$tc('lang.factoryReport.Disadvantage')"
          :label-col="{ span: 3 }"
          :wrapper-col="{ span: 10 }"
        >
          <div v-for="(item, index) in freportDisadvantage" :key="index">
            <a-input v-model="freportDisadvantage[index]" />
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      factoryDetails: JSON.parse(
        JSON.stringify(this.$store.state.report.factoryDetails),
      ),
      id: this.$route.query.id,
      freportAdvantage: [],
      freportDisadvantage: [],
    };
  },
  created() {
    this.freportAdvantage =
      this.factoryDetails.freportAdvantage == ''
        ? ['']
        : JSON.parse(this.factoryDetails.freportAdvantage) || [''];
    this.freportDisadvantage =
      this.factoryDetails.freportDisadvantage == ''
        ? ['']
        : JSON.parse(this.factoryDetails.freportDisadvantage) || [''];
  },
  computed: {
    data: {
      get() {
        return this.$store.state.report.factoryDetails;
      },
      set(val) {
        this.$store.commit('report/save', { factoryDetails: val });
      },
    },
  },
  methods: {
    save() {
      this.$http
        .post('/hzwmj/workorder-factoryreport/saveOrUpdateFactoryreport', {
          ...this.factoryDetails,
          freportAdvantage: JSON.stringify(this.freportAdvantage),
          freportDisadvantage: JSON.stringify(this.freportDisadvantage),
        })
        .then(data => {
          if (data) {
            this.$message.success('保存成功');
            // this.$store.commit('report/save', { details: data });
            this.getDetail();
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
    getDetail() {
      this.$http
        .post('/hzwmj/workorder-factoryreport/seachFactoryreport', {
          id: this.id,
        })
        .then(data => {
          if (data.data) {
            this.factoryDetails = data.data;
          } else {
            this.factoryDetails = {};
          }
        })
        .catch(() => {
          this.factoryDetails = {};
        });
    },
  },
};
</script>
<style lang="less">
.generalEstimate {
  .generalEstimate-con {
    display: flex;
    form {
      flex-grow: 1;
      .ant-form-item-label {
        text-align: left;
        padding-left: 20px;
      }
      .spanGroup {
        display: flex;
        .span1 {
          width: 130px;
        }
        .span2 {
          margin: 0 40px;
        }
        .span3 {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
